import React from "react";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import { useRecentPlayTests, useGame } from "@seabrookstudios/pitch2table";
import { Link } from "react-router-dom";
import { Path } from "../Path";
import { CoverSquare } from "../games/CoverImages";
import ListItemText from "@mui/material/ListItemText";
import Chip from "@mui/material/Chip";
import ListItemSecondaryAction from "@mui/material/ListItemSecondaryAction";
import { useFormatPlayers } from "../play-tests/FormatPlayers";

/**
 * Custom PlayTest entry for dashboard with game logo and duration
 * @param {object} props
 * @param {import("@seabrookstudios/pitch2table-core").PlayTest} props.item
 */
const RecentPlayTestEntry = ({ item }) => {
  const { data: game } = useGame(item.gameId);
  const players = useFormatPlayers([item], item.gameId);

  return (
    <ListItem>
      <ListItemButton alignItems="flex-start" component={Link} to={Path.game(item.gameId).test(item.id)}>
        <ListItemAvatar>{game && <CoverSquare game={game} />}</ListItemAvatar>
        <ListItemText primary={game ? game.name : ""} secondary={players} />
        <ListItemSecondaryAction>
          {item.duration && <Chip label={`${item.duration}m`} size="small" />}
        </ListItemSecondaryAction>
      </ListItemButton>
    </ListItem>
  );
};

export const RecentPlayTestsCard = () => {
  const { data: playTests = [], isLoading } = useRecentPlayTests();

  if (isLoading || playTests.length === 0) {
    return null;
  }

  return (
    <Card>
      <CardHeader title="Recent Play Tests" subheader="Play tests from the last 7 days" />
      <CardContent>
        <List dense>
          {playTests.map((playTest) => (
            <RecentPlayTestEntry item={playTest} key={playTest.id} />
          ))}
        </List>
      </CardContent>
    </Card>
  );
};
